import { CheckIcon } from './Icons';
import { PLACE_FILTER_CATEGORIES, type PlaceFilterCategory } from '@/lib/interests';

interface CategoryChipRowProps {
  value: PlaceFilterCategory;
  onChange: (next: PlaceFilterCategory) => void;
  categories?: typeof PLACE_FILTER_CATEGORIES;
}

export function CategoryChipRow({
  value,
  onChange,
  categories = PLACE_FILTER_CATEGORIES,
}: CategoryChipRowProps) {
  return (
    <div className="chip-row" role="tablist" aria-label="Category">
      {categories.map((c) => {
        const selected = value === c.key;
        return (
          <button
            key={c.key}
            type="button"
            role="tab"
            aria-selected={selected}
            className={`interest-chip ${selected ? 'interest-chip--on' : ''}`}
            onClick={() => onChange(c.key)}
          >
            <CheckIcon checked={selected} />
            <span>{c.label}</span>
          </button>
        );
      })}
    </div>
  );
}
